import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Button } from '../../../ui-kit/Button/Button';
import { Card } from '../../../ui-kit/Card/Card';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { BlogStorageFormatsConnected } from '../../content/media';
import { PlanUsage } from './PlanUsage/PlanUsage';

// PLAN-UC-5: свой тариф и израсходованное — секция профиля.
export function MyPlanSection(): ReactElement {
  const { api } = useServices();
  const { t } = useT();
  const account = useResource(() => api.plans.mine(), [api]);
  return (
    <Card title={t('plans.usage.title')}>
      {account.loading && !account.data ? (
        <Loading label={t('common.loading')} />
      ) : account.error || !account.data ? (
        <Alert tone="danger" title={t('common.loadFailed')}>
          <Button size="sm" onClick={() => void account.reload()}>
            {t('common.retry')}
          </Button>
        </Alert>
      ) : (
        <PlanUsage account={account.data} showChangeHint blogFormats={(blogId) => <BlogStorageFormatsConnected blogId={blogId} />} />
      )}
    </Card>
  );
}
